// extracted by css-extract-rspack-plugin
export default {"open":"IssueStatusIcon-module__open__CxJhh","done":"IssueStatusIcon-module__done__qu5X6","muted":"IssueStatusIcon-module__muted__Aw_MK"};